import styled from 'styled-components'

export const StyledNewsSelectedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
  padding: 0 0 15px;
`
